<template>
  <el-popconfirm title="确定删除吗？"
                 :disabled="disabled"
                 iconColor="#ff0000"
                 @confirm="del()">
    <el-link v-if="type=='icon'"
             :underline="false"
             @click.native="clc()"
             slot="reference"
             :title="label"
             :disabled="disabled"
             type="danger"><i class="el-icon-font el-icon-shanchu"></i></el-link>
    <el-button v-if="type=='button'"
               slot="reference"
               type="danger"
               icon="el-icon-font el-icon-shanchu"
               :disabled="disabled"
               size="mini">{{label}}</el-button>
  </el-popconfirm>
</template>

<script>
export default {
  name: 'esDelete',
  props: {
    disabled: {
      default: false
    },
    type: {
      required: true
    },
    label: {
      default: '删除'
    }
  },
  methods: {
    del () {
      this.$emit('del')
    },
    clc () {
      event.stopPropagation()//防止冒泡
    }
  }
}
</script>

<style scoped>
</style>